import { useSiteContent } from "../lib/content";
import { AdminSaveForm, parseBase } from "./AdminSaveForm";
import { adminFieldClass, adminLabelClass } from "./adminFields";

export function AdminInicio() {
  const { content } = useSiteContent();
  const hero = content.hero;

  return (
    <AdminSaveForm
      title="Início"
      hint="Textos do bloco principal no topo do site."
      build={(form) => ({
        ...parseBase(form),
        hero: {
          eyebrow: String(form.get("eyebrow") ?? ""),
          title: String(form.get("title") ?? ""),
          subtitle: String(form.get("subtitle") ?? ""),
          ctaPrimary: String(form.get("ctaPrimary") ?? ""),
          ctaSecondary: String(form.get("ctaSecondary") ?? ""),
        },
      })}
    >
      <label className={adminLabelClass}>
        Linha pequena
        <input name="eyebrow" className={adminFieldClass} defaultValue={hero.eyebrow} />
      </label>
      <label className={adminLabelClass}>
        Título
        <input name="title" className={adminFieldClass} defaultValue={hero.title} />
      </label>
      <label className={adminLabelClass}>
        Texto
        <textarea name="subtitle" rows={4} className={adminFieldClass} defaultValue={hero.subtitle} />
      </label>
      <div className="grid gap-4 sm:grid-cols-2">
        <label className={adminLabelClass}>
          Botão principal
          <input name="ctaPrimary" className={adminFieldClass} defaultValue={hero.ctaPrimary} />
        </label>
        <label className={adminLabelClass}>
          Botão secundário
          <input name="ctaSecondary" className={adminFieldClass} defaultValue={hero.ctaSecondary} />
        </label>
      </div>
    </AdminSaveForm>
  );
}
